export default __webpack_public_path__ + "static/botblocker2-7a74354e30e30e2f3a72b3c0845b658c.png";